export const hotelHeadings = [
  { name: "Hotel Name", width: 50 },
  { name: "SOA Mail", width: 50 },
  { name: "Actions", width: 50 },
];
